// FRAMEWORK
import React, { useContext } from 'react'
import { navigate } from 'gatsby'
import { useInfiniteHits, useSearchBox } from 'react-instantsearch'
import ProductCardMini from '../components/product-card-mini'
import useGetAllBuilderProducts from '../hooks/useGetAllBuilderProducts'
import AppContext from '../context/app'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import slug from 'slug'
import { ReactComponent as X } from '../images/x-close-icon-white.svg'

const DEFAULT_SKUS = ['ARSF1','ARSC1','MP044']

export default function Results() {
    // https://www.algolia.com/doc/api-reference/widgets/infinite-hits/react/#hook-usage
    const { clear } = useSearchBox()
    const { results } = useInfiniteHits()

    const { searchClicked, setSearchClicked } = useContext(AppContext)
    const defaultResults = useGetAllBuilderProducts()?.filter(({ sku }) => DEFAULT_SKUS.includes(sku))

    const arr = results?.query ? results?.hits : defaultResults

    if (!results?.query && !searchClicked) return <></>
    return (
        <Container fluid
            className='d-flex pt-md-5 pt-3 position-absolute'
            style={{
                left: 0,
                top: '100%',
                height: '100vh',
                background: `linear-gradient(180deg, #000 0%, rgba(0, 0, 0, 0.90) 50.07%, rgba(0, 0, 0, 0.50) 100%)`,
            }}
        >
            <Container>
                {/* SUGGESTED PRODUCTS LINE */}
                <p className='text-secondary ff-primary fw-bold'>
                    SUGGESTED PRODUCTS
                </p>

                {/* 3 MINI PRODUCT CARDS */}
                <Row md={3}>
                    {arr.slice(0, 3).map((p, i) => {
                        return (
                            <Col key={slug(`${p.name}-search-result`)}>
                                <ProductCardMini
                                    product={p}
                                    onClick={clear}
                                />
                            </Col>
                        )
                    })}
                </Row>

                {/* VIEW ALL RESULTS BUTTON */}
                <p className='d-flex justify-content-center gap-3 mb-0 mt-md-4'>
                    <Button
                        variant='outline-light'
                        className='d-flex align-items-center gap-2'
                        css={{
                            '& path': {
                                transition: 'fill .25s ease',
                                fill: 'white',
                            },
                            '&:hover': {
                                '& path': {
                                    fill: 'black',
                                }
                            }
                        }}
                        title='Press (esc) to close'
                        onClick={() => {
                            clear()
                            setSearchClicked(false)
                        }}
                    >
                        <X width={24} height={24}/>
                        CLOSE SEARCH
                    </Button>
                    <Button
                        onClick={() => {
                            navigate('/search', { state: results })
                            setSearchClicked(false)
                            clear()
                        }}
                    >
                        VIEW ALL SEARCH RESULTS ({results?.nbHits})
                    </Button>
                </p>
            </Container>
        </Container>
    )
}
